export function SearchIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M4.875 11a6.125 6.125 0 1112.25 0 6.125 6.125 0 01-12.25 0zM11 3.125a7.875 7.875 0 104.529 14.318l3.264 3.264a1 1 0 001.414-1.414l-3.2-3.2A7.875 7.875 0 0011 3.125z"
      ></path>
    </svg>
  );
}
